<template>
<Menu class="aside themeable" theme="light" ref="contactMenu" accordion style="position: relativ;" :style="isMinSize&&!isMouseFocus?'width:60px;':'width:180px;'" :active-name="activeMenu" :open-names="openMenu">
    <!-- 180px的导航 -->
    <!-- <div style="width:100%;height:112px;text-align: center;border-bottom: 1px solid #F5F6FA;padding-bottom: 20px;margin-bottom: 14px;">      
      <img style="width: 50px;height: 50px;margin-top: 20px;" :src="menuImg" />
      <div style="font-size:14px;font-weight:bold;">{{parentMenu.Name}}</div>      
    </div> -->
    <div v-if="!isMinSize" class="bigMenu">
        <template v-for="(item, index) in menuList" :name="index">
            <MenuChildItem :display="false" :item="item" :key="item.Id"></MenuChildItem>
        </template>
    </div>
    <div v-else-if="isMouseFocus" class="bigMenu"  @mousemove="changeMouseFocus" @mouseleave="changeMouseleave">
        <template v-for="(item, index) in menuList" :name="index">
            <MenuChildItem :display="false" :item="item" :key="item.Id"></MenuChildItem>
        </template>
    </div>
    <div v-else class="min" @mousemove="changeMouseFocus" @mouseleave="changeMouseleave">
        <template v-for="(item, index) in menuList" :name="index">
            <MenuChildItem :display="true" :item="item" :key="item.Id"></MenuChildItem>
        </template>
    </div>
    
    <div class="bottomMenu">
        <icon v-if="isMinSize==false" custom="iconfont menu_shouqi" color="#C1C3C6" @click="changeMinSize"/>
        <icon v-else custom="iconfont menu_zhankai" color="#C1C3C6" @click="changeMinSize"/>
    </div>
</Menu>
</template>

<script>
import {
    mapGetters
} from "vuex";
import Vue from 'vue';
import childItem from './childItem.vue'
Vue.component('MenuChildItem', childItem);
export default {
    data() {
        return {
            // 是否切换导航尺寸的标识
            isMinSize: this.$store.getters.getisMinSize||false,
            isMouseFocus: false,
            // 控制切换导航的频率 节流阀
            isAbleChangeSize: true,
            childsMenu: [],
            parentMenu: {}
        };
    },
    watch: {
        //由父组件调用
        // currentMenu(_value) {
        //    this.tiggerMenuActive(_value);
        // }
    },
    created() {
    },
    computed: {
        openMenu() {
            let l = this.currentMenu.length;
            if (l > 1) {
                return this.currentMenu.slice(0, l - 1)
            }
            return [];
        },
        activeMenu() {
            var l = this.currentMenu.length;
            var currentMenu=this.currentMenu[1];
            this.$nextTick(() => {
                this.$refs.contactMenu.updateOpened(this.currentMenu.slice(0, l - 1)[0]);
                this.$refs.contactMenu.updateActiveName(currentMenu);
            })
            if (l == 1 || (this.isMinSize&&!this.isMouseFocus)) {
                return this.currentMenu[0];
            }else{
                return this.currentMenu[1];
            }
            return 0;
        },
        ...mapGetters({
            currentMenu: 'getCurrentMenu',
            menuList: 'getParentMenuList'
        }),
        menuImg() {
            return '/static/hamster-theme/img/menu/' + this.parentMenu.Img
        }
    },
    methods: {
        goToLink(url) {
            this.$router.push(url);
        },
        getOnLevelMenu(menuId) {
            this.parentMenu = this.$store.getters.getMenuInfo(menuId);
        },
        changeMinSize(){
            this.isMinSize=!this.isMinSize;
            this.$store.dispatch('setMinSize',{
            isMinSize:this.isMinSize
          });
        },
        changeMouseFocus(){
            this.isMouseFocus=true;
        },
        changeMouseleave(){
            this.isMouseFocus=false;
        },
        tiggerMenuActive(_value){
             let _self = this;
            if (_value.length == 0) return;
            let activePMenu = _self.currentMenu[0];
            if (activePMenu == undefined || activePMenu == null) return;
            this.getOnLevelMenu(activePMenu);
            let menus = _self.$store.getters.getMenuChilds(activePMenu);
            _self.childsMenu = menus;
            _self.$nextTick(() => {
                _self.$refs.contactMenu.updateOpened(_self.openMenu);
                _self.$refs.contactMenu.updateActiveName(_self.activeMenu);
            });
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .aside  *{
   -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none; 

}


.min {
    float: left;
    width:60px;
    .bigMenu {
        display: none;
    }

    .smallMenu {
        display: block;
    }
    
}
.bottomMenu{
        bottom: 0;
        cursor: pointer;
        position: absolute;
        text-align: center;
        padding: 15px 21px;
}  
.smallMenu {
    display: none;
}

.iconWrapper {
    text-align: right;
    height: 50px;
    position: relative;
    
}

.btnSize {
    position: absolute;
    right: 17.5px;
    top: 13px;
    width: 50px;
    height: 50px;
    color: #fff;
    cursor: pointer;
}

.ivu-menu-vertical .ivu-menu-item,
.ivu-menu-vertical .ivu-menu-submenu-title {
    color: #fff;
}
.ivu-menu-vertical .ivu-menu-item:hover{
    color: #ff5858;
}
.ivu-menu-vertical .ivu-menu-item-active,
.ivu-menu-vertical .ivu-menu-item-selected {
    background: #444444 !important;
}

.ivu-menu-vertical .ivu-menu-submenu {
    color: #fff;
}

.ivu-menu-vertical .ivu-menu .ivu-menu-item {
    height: 40px;
    padding: 0;
    line-height: 40px;
    color: #9FA1A4;
    background: #191919;
    padding-left: 58px !important;
}

.ivu-menu-vertical .ivu-menu .ivu-menu-item-active,
.ivu-menu-vertical .ivu-menu .ivu-menu-item-selected {
    background: #282b35 !important;
}

.ivu-menu-vertical.ivu-menu-light:after {
    width: 0;
}

.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
    left: 0;
    width: 4px;
}

.bigMenu {
    height: 100%; 
    overflow-y: auto;
    overflow-x: hidden;
    box-shadow: 2px 5px 5px #ccc;

    z-index: 30;
    i {
        font-family: "iconfont";
    }
    .bottomMenu{
        bottom: 0;
        left:0;
        right: 0;
        position:absolute;
        text-align: center;
        padding: 15px 21px;
    }   
}

</style>


// WEBPACK FOOTER //
// src/components/aside/aside.vue